import React, { useState } from "react";
import { Table, Tag, Spin } from "antd";
import dayjs from "dayjs";
import { DateFormat } from "../Components/Constant";
import {convertDateToUserTimezone} from '../Components/Utility';

const JCBLogs = ({ logEntries, logDataLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  // Filter out relevant JCB data
  const jcbLogs = logEntries
    .map((log) => ({
      date: convertDateToUserTimezone(log.Date,DateFormat),
      jcb_number: log.JCBNumber?.JCBNumber || null, // Use null instead of "N/A" for easier filtering
      driver: log.Driver?.Name || "N/A",
      contractor: log.Contractor?.Name || "N/A",
      jcb_usage: log.JCBUsage || 0,
      alert: log.Alert,
    }))
    .filter((log) => log.jcb_number);

  const columns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "JCB Number", dataIndex: "jcb_number", key: "jcb_number" },
    { title: "Driver", dataIndex: "driver", key: "driver" },
    { title: "Contractor", dataIndex: "contractor", key: "contractor" },
    { title: "JCB Usage (hours)", dataIndex: "jcb_usage", key: "jcb_usage" },
    {
      title: "Alerts",
      render: (_, record) => {
        const highJCBUsage = record.jcb_usage > 8;
        return (
          <>
            {highJCBUsage && <Tag color="orange">High JCB Usage</Tag>}
          </>
        );
      },
      key: "jcb_alerts",
      fixed: "right",
    },
  ];

  return (
    <div>
      <h3>JCB Logs</h3>
      <Spin spinning={logDataLoading}>
        <Table
          dataSource={jcbLogs}
          columns={columns}
          rowKey="date"
          style={{ marginTop: 20 }}
          pagination={{
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, pageSize) => {
              setCurrentPage(page); 
            },              
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }} 
          scroll={{ x: "max-width", y: 180 }}
        />
      </Spin>
    </div>
  );
};

export default JCBLogs;